import api from '../libs/api';

export default {

getDashboardStatusReport: (page, status, formId, initiatorIds, fromDate, toDate, userType) => {
  return api().get(`/dashboard/status-report`, {
    params: {
      page: page,
      status: status,
      user_type: userType || 1,
      form_id: formId,
      ...(initiatorIds && initiatorIds.length > 0 && { initiators: initiatorIds.join(",") }),
      ...(fromDate && { from_date: fromDate }),
      ...(toDate && { to_date: toDate }),
    },
  }).then(res => res.data);
},

}